export default Object.freeze({
  visit: 1,
  summary: 2,
});
